import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubordinatesInBuComponent } from './subordinates-in-bu.component';

@NgModule({
  declarations: [SubordinatesInBuComponent],
  imports: [
    CommonModule
  ],
  exports: [SubordinatesInBuComponent],
  entryComponents: [SubordinatesInBuComponent]
})
export class SubordinatesInBuModule { }
